module.exports = __webpack_public_path__ + "img/l_r_vid_1_splash.379bf94b.jpg";